import type { Distance, SpatialRectangle } from "@pdfking/math"
import { BoundingBox, GetXY } from "@pdfking/math"

import type { Matrix } from "#public"

import { MatrixApply } from "./MatrixApply"

/** The axis-aligned box `box` lands in, seen through `matrix`: its corners
 * taken through it and squared back up. A quarter turn keeps it exact; any
 * other angle gives its bounding box. */
export const MatrixBox = (
  matrix: Matrix<Distance>,
  box: SpatialRectangle<Distance>
): SpatialRectangle<Distance> => {
  const { x1, x2, y1, y2 } = GetXY(box)
  return BoundingBox(
    ...[
      { x: x1, y: y1 },
      { x: x2, y: y1 },
      { x: x1, y: y2 },
      { x: x2, y: y2 },
    ].map(p => MatrixApply(matrix, p))
  )
}
